import { render, staticRenderFns } from "./ModalityView.vue?vue&type=template&id=840b4ade&scoped=true"
import script from "./ModalityView.vue?vue&type=script&lang=js"
export * from "./ModalityView.vue?vue&type=script&lang=js"
import style0 from "./ModalityView.vue?vue&type=style&index=0&id=840b4ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b4ade",
  null
  
)

export default component.exports